
import React, { useState, useEffect } from "react";
import { supabase } from "./supabase";

const FREE_SCAN_LIMIT = 3;
const API = "https://api.assetgraph.ai";

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" style={{flexShrink:0}}>
      <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.716v2.259h2.908C16.658 14.115 17.64 11.807 17.64 9.2z"/>
      <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"/>
      <path fill="#FBBC05" d="M3.964 10.706c-.18-.54-.282-1.117-.282-1.706s.102-1.166.282-1.706V4.962H.957C.347 6.175 0 7.55 0 9s.348 2.825.957 4.038l3.007-2.332z"/>
      <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.962L3.964 6.294C4.672 4.167 6.656 3.58 9 3.58z"/>
    </svg>
  );
}

export function AuthModal({ onClose, onSuccess }) {
  const [view, setView] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const inputStyle = {
    width:"100%", background:"#141820", border:"1px solid #2A3347",
    borderRadius:8, padding:"11px 14px", color:"#E8EBF0",
    fontSize:14, outline:"none", boxSizing:"border-box", fontFamily:"inherit",
  };

  const handleGoogle = async () => {
    setGoogleLoading(true);
    setError("");
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo: "https://assetgraph.ai" },
    });
    if (error) { setError(error.message); setGoogleLoading(false); }
  };

  const handleEmailAuth = async () => {
    if (!email || !password) { setError("Email and password required"); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters"); return; }
    setLoading(true); setError(""); setMessage("");
    try {
      let result;
      if (view === "signup") {
        result = await supabase.auth.signUp({ email, password });
        if (result.error) throw result.error;
        if (!result.data.session) {
          setMessage("Check your email to confirm, then sign in.");
          setLoading(false); return;
        }
      } else {
        result = await supabase.auth.signInWithPassword({ email, password });
        if (result.error) throw result.error;
      }
      const { session, user } = result.data;
      try {
        const res = await fetch(API + "/auth/me", {
          headers: { "Authorization": "Bearer " + session.access_token }
        });
        const profile = await res.json();
        onSuccess({ ...profile, email: user.email }, session.access_token);
      } catch {
        onSuccess({ id:user.id, email:user.email, plan:"free",
          scans_used:0, scans_limit:FREE_SCAN_LIMIT }, session.access_token);
      }
    } catch (e) { setError(e.message || "Authentication failed"); }
    setLoading(false);
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.88)", zIndex:2000, display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div style={{ background:"#0E1118", border:"1px solid #1E2535", borderRadius:16, padding:32, width:400, maxWidth:"92%" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:24 }}>
          <div>
            <div style={{ color:"#00E87A", fontSize:10, fontFamily:"monospace", letterSpacing:"0.15em", marginBottom:6 }}>ASSETGRAPH</div>
            <h2 style={{ color:"#fff", fontSize:22, fontWeight:700, letterSpacing:"-0.02em", margin:0 }}>
              {view === "login" ? "Welcome back" : "Create account"}
            </h2>
            {view === "signup" && <p style={{ color:"#525E72", fontSize:13, marginTop:4, marginBottom:0 }}>{FREE_SCAN_LIMIT} free scans included</p>}
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", color:"#525E72", cursor:"pointer", fontSize:20, padding:4 }}>x</button>
        </div>

        {view === "signup" && (
          <div style={{ background:"#00E87A08", border:"1px solid #004D29", borderRadius:8, padding:"10px 14px", marginBottom:16 }}>
            <div style={{ color:"#00E87A", fontSize:12, fontWeight:600, marginBottom:4 }}>Free tier includes:</div>
            <div style={{ color:"#8B95A8", fontSize:12, lineHeight:1.6 }}>3 scans · Supply chain SCA · CVE matching</div>
          </div>
        )}

        <button onClick={handleGoogle} disabled={googleLoading} style={{ width:"100%", background:"#fff", border:"none", borderRadius:10, padding:"11px", display:"flex", alignItems:"center", justifyContent:"center", gap:10, cursor:googleLoading?"default":"pointer", fontSize:14, fontWeight:600, color:"#1a1a1a", marginBottom:16, opacity:googleLoading?0.7:1 }}>
          <GoogleIcon />
          {googleLoading ? "Redirecting..." : "Continue with Google"}
        </button>

        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16 }}>
          <div style={{ flex:1, height:1, background:"#1E2535" }} />
          <span style={{ color:"#525E72", fontSize:12, fontFamily:"monospace" }}>or</span>
          <div style={{ flex:1, height:1, background:"#1E2535" }} />
        </div>

        <div style={{ marginBottom:12 }}>
          <label style={{ display:"block", color:"#525E72", fontSize:11, fontFamily:"monospace", letterSpacing:"0.1em", marginBottom:6 }}>EMAIL</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key==="Enter" && handleEmailAuth()} placeholder="you@example.com" style={inputStyle} />
        </div>

        <div style={{ marginBottom:16 }}>
          <label style={{ display:"block", color:"#525E72", fontSize:11, fontFamily:"monospace", letterSpacing:"0.1em", marginBottom:6 }}>PASSWORD</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key==="Enter" && handleEmailAuth()} placeholder="Minimum 6 characters" style={inputStyle} />
        </div>

        {error && <div style={{ color:"#FF4D6A", fontSize:12, marginBottom:14, padding:"8px 12px", background:"#FF4D6A10", borderRadius:6, border:"1px solid #FF4D6A30" }}>{error}</div>}
        {message && <div style={{ color:"#00E87A", fontSize:12, marginBottom:14, padding:"8px 12px", background:"#00E87A10", borderRadius:6, border:"1px solid #00E87A30" }}>{message}</div>}

        <button onClick={handleEmailAuth} disabled={loading} style={{ width:"100%", background:loading?"#1E2535":"#00E87A", border:"none", borderRadius:10, padding:"12px", color:loading?"#525E72":"#000", fontWeight:700, fontSize:14, cursor:loading?"default":"pointer", marginBottom:16 }}>
          {loading ? "..." : view==="login" ? "Sign in" : "Create free account"}
        </button>

        <div style={{ textAlign:"center", color:"#525E72", fontSize:13 }}>
          {view === "login" ? (
            <>No account? <span onClick={() => { setView("signup"); setError(""); setMessage(""); }} style={{ color:"#00E87A", cursor:"pointer", fontWeight:600 }}>Sign up free</span></>
          ) : (
            <>Have an account? <span onClick={() => { setView("login"); setError(""); setMessage(""); }} style={{ color:"#00E87A", cursor:"pointer", fontWeight:600 }}>Sign in</span></>
          )}
        </div>
      </div>
    </div>
  );
}

export function useAuth() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        setToken(session.access_token);
        fetch(API + "/auth/me", { headers: { "Authorization": "Bearer " + session.access_token } })
          .then(r => r.json())
          .then(profile => setUser({ ...profile, email: session.user.email }))
          .catch(() => setUser({ email:session.user.email, plan:"free", scans_used:0, scans_limit:FREE_SCAN_LIMIT }));
      }
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (session && event === "SIGNED_IN") {
        setToken(session.access_token);
        try {
          const res = await fetch(API + "/auth/me", { headers: { "Authorization": "Bearer " + session.access_token } });
          const profile = await res.json();
          setUser({ ...profile, email: session.user.email });
        } catch {
          setUser({ email:session.user.email, plan:"free", scans_used:0, scans_limit:FREE_SCAN_LIMIT });
        }
      } else if (event === "SIGNED_OUT") {
        setUser(null); setToken("");
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  const logout = async () => { await supabase.auth.signOut(); setUser(null); setToken(""); };
  return { user, token, loading, setUser, setToken, logout };
}
